/**
 * Banner showing pending payments count with action to switch to verification tab.
 */

import { IconClock, IconChevronRight } from "../../../../components/Icons.tsx";
import { haptic } from "../../../../lib/telegram.ts";

interface PendingPaymentsBannerProps {
  count: number;
  onNavigate?: () => void;
}

export function PendingPaymentsBanner({ count, onNavigate }: PendingPaymentsBannerProps) {
  if (count === 0) {
    return null;
  }

  const label =
    count === 1
      ? "платёж ожидает"
      : count < 5
        ? "платежа ожидают"
        : "платежей ожидают";

  const handleClick = () => {
    haptic("light");
    onNavigate?.();
  };

  return (
    <button
      type="button"
      onClick={handleClick}
      className="w-full card p-4 bg-amber-50 border-amber-200 active:opacity-90 transition-opacity text-left"
    >
      <div className="flex items-center justify-between">
        <div className="flex items-center gap-3">
          <div className="w-10 h-10 rounded-xl bg-amber-100 flex items-center justify-center">
            <IconClock className="w-5 h-5 text-amber-600" />
          </div>
          <div>
            <p className="text-[15px] font-semibold text-amber-800">
              {count} {label} проверки
            </p>
            <p className="text-[12px] text-amber-600">
              Нажмите для просмотра
            </p>
          </div>
        </div>
        <IconChevronRight className="w-5 h-5 text-amber-400" />
      </div>
    </button>
  );
}
